// extracted by mini-css-extract-plugin
export default {"outer-wrapper":"ZWcSnf","outerWrapper":"ZWcSnf","wrapper":"xW8s6c"};